/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import "../../../assets/styles/custom-style.css";

import { useAuth } from "../../../auth";
import { useParams } from "react-router-dom";

import {
  deleteCoupon,
} from "../core/_requests";
import { useNavigate } from "react-router-dom";


const DeleteCoupon = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const deleteItem = () => {
        deleteCoupon(id)
      .then((res) => {
         // Add this line
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
    navigate("/coupon");
  };

  const clickCancel = () => {
    navigate("/coupon");
  };

  return (
    <>
      <section className="container-fluid">
        <div className="row">

          <div className="overlay"></div>
          <div className="drawer small">
            <div className="alert-wrap">
              <img
                className="ico mb-4"
                src="/assets/images/alert-warning-ico.svg"
                alt="success"
              />
              <h1 className="mb-3">Are you sure?</h1>
              <p className="mid-gray mb-4 text-center">
                <small>
                  Do you want delete this Coupon. You can n't retrieve
                  <br />
                  this coupon if you delete
                </small>
              </p>
              <button
                className="btn btn-danger rounded-5 px-5 mt-2 mb-2"
                onClick={deleteItem}
              >
                Yes, Delete
              </button>
              <button
                className="btn btn-cancel rounded-5"
                onClick={clickCancel}
              >
                No, I don't want to delete
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeleteCoupon;
